import { render, staticRenderFns } from "./CampaignPeopleForm.vue?vue&type=template&id=0bb9432d"
import script from "./CampaignPeopleForm.vue?vue&type=script&lang=js"
export * from "./CampaignPeopleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports